"use strict";
exports.__esModule = true;
exports.MEMBERSHIP_FEE = void 0;
exports.MEMBERSHIP_FEE = {
    HEADER: 'Membership fee',
    BODY: 'Your membership gives you access to the Flex services. It will automatically renew each month until you cancel.',
    LEARN_MORE: 'Learn more about membership',
    CTA: 'Close'
};
